import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import DefaultUi from '../../components/DefaultUi';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})
export default class NoCookies extends React.Component {
  render() {
    const  locale = this.props.locale;
    const bundle = get_bundle(locale);

    return (
      <DefaultUi id="no_cookies" title={bundle.no_cookies.title}>
        <div className="cols">
          <div className="large-100">
            <div className="cell">
              {bundle.no_cookies.body}
            </div>
          </div>
        </div>
      </DefaultUi>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/NoCookies.js
 **/